// UpgradePrompt.tsx
// Componente inline que reemplaza un breakdown gateado cuando el usuario es free.
// Muestra contenido placeholder con blur + mensaje de upgrade.

import React from 'react';
import { useT } from '../../lib/i18n';

interface Props {
  /** Nombre del feature bloqueado, ej: "CBet by board texture" */
  feature: string;
  /** Callback para abrir el UpgradeModal desde App.tsx */
  onUpgrade?: () => void;
}

// Filas fantasma para dar la sensación de contenido bloqueado
function GhostRows() {
  return (
    <div className="upgrade-ghost-rows" aria-hidden="true">
      {[70, 55, 85, 40, 62].map((w, i) => (
        <div key={i} className="upgrade-ghost-row">
          <div className="upgrade-ghost-label" style={{ width: `${w}%` }} />
          <div className="upgrade-ghost-value" />
        </div>
      ))}
    </div>
  );
}

export function UpgradePrompt({ feature, onUpgrade }: Props) {
  const { t } = useT();

  return (
    <div className="upgrade-prompt">
      {/* Contenido placeholder con blur encima */}
      <GhostRows />

      {/* Overlay con mensaje */}
      <div className="upgrade-prompt-overlay">
        <span className="upgrade-prompt-lock">◈</span>
        <p className="upgrade-prompt-text">
          {t('stats.upgradePrompt.text', { feature })}
        </p>
        <button
          className="btn upgrade-prompt-btn"
          onClick={onUpgrade}
          type="button"
        >
          {t('stats.upgradePrompt.btn')}
        </button>
      </div>
    </div>
  );
}
